'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WEIGHTS = exports.WEIGHTS = {
  regular: 'regular',
  medium: 'medium',
  bold: 'bold',
  demi: 'demi'
};

var USES = exports.USES = {
  error: 'error',
  help: 'help',
  success: 'success'
};